import { ApiErrorCategories } from "./api-error-categories";
import { ApiResultCode } from "./api-result-code";
var ApiResultError = /** @class */ (function () {
    function ApiResultError(code, name, description) {
        this._code = code;
        this._name = name;
        this._description = description;
        ApiResultError.setCategory(code);
    }
    Object.defineProperty(ApiResultError.prototype, "code", {
        get: function () {
            return this._code;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiResultError.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiResultError.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApiResultError.prototype, "category", {
        get: function () {
            return this._category;
        },
        enumerable: true,
        configurable: true
    });
    ApiResultError.setCategory = function (code) {
        switch (code) {
            case ApiResultCode.ERROR_AUTHENTICATION_FROM_TOKEN_FAILED:
            case ApiResultCode.ERROR_AUTHENTICATION_REQUIRED:
            case ApiResultCode.ERROR_CANNOT_FIND_ORGANIZATION:
            case ApiResultCode.ERROR_CREATE_CUSTOMER:
            case ApiResultCode.ERROR_ITEM_NOT_PUBLISHED:
            case ApiResultCode.ERROR_SUBMIT_WRONG_PRIORITY:
            case ApiResultCode.ERROR_SUBMIT_TYPE_IS_WRONG:
            case ApiResultCode.ERROR_SUBMIT_TYPE_IS_REQUIRED:
            case ApiResultCode.ERROR_SUBMIT_PROJECT_NOT_PUBLISHED:
            case ApiResultCode.ERROR_SUBMIT_PROJECT_NOT_FOUND:
            case ApiResultCode.ERROR_SUBMIT_NAME_IS_REQUIRED:
            case ApiResultCode.ERROR_SUBMIT_DESCRIPTION_IS_REQUIRED:
            case ApiResultCode.ERROR_SUBMIT_ANONYMOUS_MUST_PROVIDE_EMAIL:
            case ApiResultCode.ERROR_SECURITY_ACCESS:
            case ApiResultCode.INTERNAL_ERROR:
            case ApiResultCode.UNKNOWN_ERROR:
                return ApiErrorCategories.DANGER;
            case ApiResultCode.ERROR_CANNOT_FIND_CUSTOMER:
            case ApiResultCode.ERROR_CANNOT_FIND_ITEM:
            case ApiResultCode.ERROR_CANNOT_FIND_PARENT_POST:
            case ApiResultCode.ERROR_CANNOT_FIND_RESOURCE:
            case ApiResultCode.ERROR_CANNOT_FIND_USER:
            case ApiResultCode.ERROR_INVALID_EMAIL:
            case ApiResultCode.ERROR_INVALID_FILTER:
            case ApiResultCode.ERROR_INVALID_FILTER_ID:
            case ApiResultCode.ERROR_INVALID_ID:
            case ApiResultCode.ERROR_LOGIN_FAILED:
            case ApiResultCode.ERROR_LOGIN_WITH_WRONG_ORG:
            case ApiResultCode.ERROR_MANUAL_LOGIN_FAILED:
            case ApiResultCode.ERROR_REGISTRATION_CUSTOMER_ALREADY_EXIST:
            case ApiResultCode.ERROR_USER_ALREADY_EXIST:
            case ApiResultCode.ERROR_URI_NOT_SPECIFIED:
                return ApiErrorCategories.WARNING;
            case ApiResultCode.ERROR_COOKIE_LOGIN_FAILED:
            case ApiResultCode.ERROR_COOKIE_LOGIN_FAILED_NOT_ACTIVATED:
            case ApiResultCode.ERROR_COOKIE_LOGIN_FAILED_NOT_REGISTERED:
            case ApiResultCode.ERROR_INVALID_PAGINATION:
            case ApiResultCode.ERROR_PAGINATION_NOT_SUPPORTED:
            case ApiResultCode.ERROR_PORTAL_DISABLED:
            case ApiResultCode.ERROR_REGISTRATION_NOT_ALLOWED:
            case ApiResultCode.SUCCESS:
                return ApiErrorCategories.INFO;
        }
    };
    return ApiResultError;
}());
export { ApiResultError };
//# sourceMappingURL=api-result-error.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/end-points-dto/api-dto/http/api-result-error.js
// module id = 846
// module chunks = 14